import { gql } from '@/__generated__';

export const GET_DEVICE_ALERTS_RAW_DATA = gql(`#graphql
  query GetDeviceAlertsRawData($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      alerts {
        id
        rawData
      }
    }
  }
`);
